import React from 'react';
import no_result from './imgs/no_result.png';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';

const ResultNoResult = () => {
    const { TagList } = useSelector((state: RootState) => state.search.reducer);
    return (
        <figure className={styles.figure}>
            <figcaption className={styles.figCaption}>
                <div className={styles.main}>
                    很抱歉，<span className={styles.noData}>沒有符合您查詢的產品</span>
                </div>
                <div className={styles.sub}>請調整篩選條件或重新查詢</div>
                {TagList === 'flt' && (
                    <div className={styles.sub_flt}>
                        換個方式找找看？試著在我們的
                        <a href=" https://flight.liontravel.com/category/zh-tw/index">機票專區</a>
                        搜尋
                    </div>
                )}
            </figcaption>
            <img src={no_result} alt="無搜尋結果" className={styles.img} />
        </figure>
    );
};

export default ResultNoResult;
